export enum SelectedStatus {
  SELECTED = "SELECTED",
  DECLINED = "DECLINED",
  UNSELECTED = "UNSELECTED",
  UNAVAILABLE = "UNAVAILABLE",
}

export type UnselectedFintechOfferSelection = {
  status: SelectedStatus.UNSELECTED;
};

export type DeclinedFintechOfferSelection = {
  status: SelectedStatus.DECLINED;
};

export type UnavailableFintechOfferSelection = {
  status: SelectedStatus.UNAVAILABLE;
};

export type SelectedFintechOfferSelection<T> = {
  status: SelectedStatus.SELECTED;
  offer: T;
};

export type AnyFintechOfferSelection<T> =
  | UnavailableFintechOfferSelection
  | UnselectedFintechOfferSelection
  | DeclinedFintechOfferSelection
  | SelectedFintechOfferSelection<T>;

/**
 * @deprecated Use AnyFintechOfferSelection instead
 */
export type SelectedFintechOfferStatus<T> = AnyFintechOfferSelection<T>;
